import { useState } from "react";
import { Ruler } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { api } from "@/lib/api";

export const SizeTable = ({ g }) => (
  <table className="w-full text-sm" data-testid="size-guide-table">
    <thead><tr className="bg-[#0B1D3A] text-white text-left"><th className="px-3 py-2">Talla</th><th className="px-3 py-2">Contorno de pecho (cm)</th><th className="px-3 py-2">Largo prenda (cm)</th></tr></thead>
    <tbody>{g.rows.map((r) => <tr key={r.size} className="border-b border-slate-200" data-testid={`size-guide-row-${r.size}`}><td className="px-3 py-2 font-bold">{r.size}</td><td className="px-3 py-2">{r.chest}</td><td className="px-3 py-2">{r.length}</td></tr>)}</tbody>
  </table>
);

export const SizeGuide = ({ id = "" }) => {
  const [g, setG] = useState(null);
  return (
    <Dialog onOpenChange={(o) => o && !g && api.get("/size-guide").then((r) => setG(r.data))}>
      <DialogTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#2563EB] hover:text-[#DC2626] underline underline-offset-4 transition-colors" data-testid={`size-guide-open${id && `-${id}`}`}>
          <Ruler size={15} /> Guía de tallas
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-lg" data-testid="size-guide-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl text-[#0B1D3A]">Guía de tallas FAUNNY Gear</DialogTitle></DialogHeader>
        {g ? <SizeTable g={g} /> : <div className="h-40 bg-slate-100 animate-pulse rounded" />}
        <div className="text-sm text-slate-600 space-y-2">
          <p><b className="text-[#0B1D3A]">Pecho:</b> mide el contorno por la parte más ancha, con la cinta horizontal y sin apretar.</p>
          <p><b className="text-[#0B1D3A]">Largo:</b> desde el punto más alto del hombro hasta el bajo de la prenda.</p>
          {g?.note && <p className="text-xs text-slate-500" data-testid="size-guide-note">{g.note}</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
